import AbstractScene from './AbstractScene.js';
import ButtonImageSliced from '../prefabs/ButtonImageSliced.js';
import { A2Data } from '../consts/Data.js';
import MenuA2 from '../prefabs/A2/MenuA2.js';
import A2ScreenManager from '../prefabs/A2/A2ScreenManager.js';


export default class ActiviteA2 extends AbstractScene {
    constructor() {
        super({
            key: "ActiviteA2"
        })
    }
    init(data) {
        this._init(data);
        this.activityData = A2Data;
        this.part = 1
        // this.screenLevel = 0
    }

    preload() {
        this._preload();
    }

    create() {
        this.addBackgroundMusique('minimal')
        this.addHeader("VULNÉRABILITÉ ET STRESS");
    }

    launchScene() {
        this.elements = []
        this.introContainer = this.add.container(0, 0)
        // this.introTitle = this.createTextElement(this.width / 2 + this.width, 190, this.activityData.introTitle);
        this.introTitle = this.createTextElement(this.width / 2, 190, this.activityData.introTitle).setAlpha(0);
        this.introContainer.add(this.introTitle);
        this.elements.push(this.introTitle);
        this.introImage = this.add.image(855, 315, 'A2-1').setOrigin(0).setAlpha(0)
        this.introContainer.add(this.introImage);
        this.elements.push(this.introImage);
        this.introContent1 = this.createTextElement(this.width / 2, 620, this.activityData.introContent1).setAlpha(0);
        this.introContent2 = this.createTextElement(this.width / 2, 730, this.activityData.introContent2).setAlpha(0);
        this.introContainer.add(this.introContent1);
        this.elements.push(this.introContent1);
        this.introContainer.add(this.introContent2);
        this.elements.push(this.introContent2);

        this.startBtn = new ButtonImageSliced(this, this.width / 2, 900, 320, 80, "bouton", "Démarrer").setAlpha(0)
        this.startBtn.setClickFunction(() => {
            // this.tweens.add({
            //     targets: this.introContainer,
            //     x: 1920,
            //     duration: 400,
            //     ease: 'Power2',
            //     onComplete: () => {
            //         this.introContainer.destroy()
            //         this.launchActivity()
            //     }
            // })
            this.elements.pop();
            this.elements.reverse();
            this.elements.forEach((el, index) => {
                this.tweens.add({
                    targets: el,
                    alpha: 0,
                    delay: index * 200,
                    duration: 200,
                    ease: 'Power2',
                    onComplete: () => {
                        if (index === this.elements.length - 1) {
                            this.introContainer.destroy()
                            this.launchActivity()
                        }
                    },
                })
            })
        })
        this.introContainer.add(this.startBtn)
        this.elements.push(this.startBtn);

        // this.tweens.add({
        //     targets: this.introTitle,
        //     x: this.width / 2,
        //     duration: 400,
        //     ease: 'Power2',
        //     onComplete: () => {
        //         this.tweens.add({
        //             targets: this.introImage,
        //             alpha: 1,
        //             duration: 200,
        //             ease: 'Power2',
        //             onComplete: () => {
        //                 this.tweens.add({
        //                     targets: this.introContent1,
        //                     alpha: 1,
        //                     duration: 200,
        //                     ease: 'Power2',
        //                     onComplete: () => {
        //                         this.tweens.add({
        //                             targets: this.introContent2,
        //                             alpha: 1,
        //                             duration: 200,
        //                             ease: 'Power2',
        //                             onComplete: () => {
        //                                 this.tweens.add({
        //                                     targets: this.startBtn,
        //                                     alpha: 1,
        //                                     duration: 200,
        //                                     ease: 'Power2',
        //                                 })
        //                             }
        //                         })
        //                     }
        //                 })
        //             }
        //         })
        //     }
        // })

        this.elements.forEach((el, index) => {
            this.tweens.add({
                targets: el,
                alpha: 1,
                delay: index * 200,
                duration: 200,
                ease: 'Power2',
            })
        })
    }
    launchActivity() {
        this.menu = new MenuA2(this, this.activityData.menuBtns);
        this.menu.setMenuState(this.part, false);
        this.screenManager = new A2ScreenManager(this, this.part);


    }
}